import React from "react";
import { Pie } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";

ChartJS.register(ArcElement, Tooltip, Legend);
export default function PieChart({ data }) {
  const chartData = {
    labels: ["Scheduled", "Open", "Closed"],
    datasets: [
      {
        label: "Auctions",
        data: [data.scheduled, data.open, data.closed],
        backgroundColor: ["#2196F3", "#4CAF50", "#f44336"],
      },
    ],
  };

  return (
    <div className="chartCard pieChart">
      <h3>My Auction Status</h3>
      <div className="pieChartContainer">
        <Pie data={chartData} />
      </div>
    </div>
  );
}
